document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-scroll-to-reviews]');
  if (!trigger) return;

  event.preventDefault();

  const headingText = trigger.dataset.scrollToReviews;
  const heading = Array.from(document.querySelectorAll('h1, h2, h3')).find(
    (element) => element.textContent.trim() === headingText
  );
  const target = heading ? heading.closest('.shopify-section') || heading : null;

  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
